import stHoneyAuth from './honeyAuth.component';
import stHoneyButton from './honeyButton.component';

export default angular
  .module('st.Integrations.Honey', ['st.Core', 'angular-cache'])
  .component('stHoneyAuth', stHoneyAuth)
  .component('stHoneyButton', stHoneyButton)
  .service('honeyService', ($http, dataService, HONEY) => ({
    refer: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        HONEY.API.REFER,
        { params },
        null,
        true
      )
  }))
  .constant('HONEY', {
    API: {
      REFER: '/api/v1/integrations/honey/refer'
    }
  });
